import classNames from 'classnames';
import { ReactNode, useRef, useState } from 'react';

import EditContact from '../forms/EditContactForm';
import PromotionTitle from '../typography/PromotionTitle';
import Dialog from './Dialog';
import Modal from './Modal';

import styles from '../../styles/popups/edit-contact-modal.module.css';

type EditContactModalProps = {
    type?: 'email' | 'phone';
    title?: ReactNode;
    withoutUpdate?: boolean;
    className?: string | null;
    onClosed?: (() => void) | null;
    onComplete?: ((response: unknown) => void) | null;
};

function EditContactModal({
    type = 'email',
    title = null,
    withoutUpdate = false,
    className = null,
    onClosed = null,
    onComplete = null,
}: EditContactModalProps) {
    const [opened, setOpened] = useState(true);
    const onFormComplete = (response: unknown) => {
        setOpened(false);
        if (onComplete !== null) {
            onComplete(response);
        }
    };
    const onClickCancel = () => {
        setOpened(false);
    };
    const onRequestClose = () => {
        setOpened(false);
    };
    const inputRef = useRef<HTMLInputElement>(null);
    const onOpened = () => {
        if (inputRef.current !== null) {
            inputRef.current.focus();
        }
    };
    return (
        <Modal
            id="edit_contact"
            opened={opened}
            withBackdrop
            withTransition
            className={classNames([styles.container, className])}
            onClosed={onClosed}
            onOpened={onOpened}
            requestClose={onRequestClose}
        >
            <Dialog>
                {title !== null ? (
                    <PromotionTitle className={styles.title}>{title}</PromotionTitle>
                ) : null}
                <EditContact
                    type={type}
                    label={title !== null ? false : null}
                    editOnly
                    withoutUpdate={withoutUpdate}
                    inputRef={inputRef}
                    onComplete={onFormComplete}
                    onClickCancel={onClickCancel}
                />
            </Dialog>
        </Modal>
    );
}

export default EditContactModal;
